"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownItemWrapper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const noop_1 = __importDefault(require("lodash-es/noop"));
const Checkbox_1 = __importStar(require("../../../Checkbox"));
const constants_1 = require("../../hoc/Tabbing/constants");
const styles_module_css_1 = __importDefault(require("./styles.module.css"));
const DropdownItemWrapper = ({ itemComponent: ItemComponent, option, selected, multiple, closeOnSelect, disabled, onSelect = noop_1.default, onRemove = noop_1.default, onHide = noop_1.default, ...props }) => {
    const handleClick = (0, react_1.useCallback)((option) => {
        if (option.fixed || option.disabled)
            return;
        if (!selected) {
            onSelect(option);
        }
        else if (multiple) {
            onRemove(option);
        }
        if (closeOnSelect && onHide) {
            onHide();
        }
    }, [onSelect, onRemove, onHide, multiple, selected, closeOnSelect]);
    return ((0, jsx_runtime_1.jsx)(ItemComponent, { ...props, label: option.label, option: option, selected: selected || option.fixed, multiple: multiple, disabled: disabled || option.disabled, onClick: handleClick }));
};
exports.DropdownItemWrapper = DropdownItemWrapper;
const DropdownMenuItem = ({ option, label, size, palette, selected = false, multiple = false, hideSelected = false, disabled = false, onClick = noop_1.default, isTabbable, }) => {
    const handleClick = (0, react_1.useCallback)(() => onClick(option), [onClick, option]);
    return (
    // eslint-disable-next-line jsx-a11y/interactive-supports-focus, jsx-a11y/click-events-have-key-events
    (0, jsx_runtime_1.jsx)("div", { role: "option", "aria-label": String(label), "aria-selected": selected, className: (0, classnames_1.default)(styles_module_css_1.default.option, size && styles_module_css_1.default[size], {
            [styles_module_css_1.default.withBorders]: !multiple,
            [styles_module_css_1.default.active]: !multiple && selected,
            [styles_module_css_1.default.disabled]: disabled,
            [styles_module_css_1.default[palette]]: palette,
        }), onClick: handleClick, ...(isTabbable ? { [constants_1.TABBING_ATTRIBUTE]: constants_1.TABBING_KEY } : {}), children: multiple && !hideSelected ? ((0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)(styles_module_css_1.default.checkbox, {
                [styles_module_css_1.default.checkboxChecked]: selected,
            }), children: (0, jsx_runtime_1.jsx)(Checkbox_1.default, { rtl: true, palette: palette, label: label, checked: selected, disabled: disabled, size: Checkbox_1.CheckboxSizes.Small }) })) : (label) }));
};
exports.default = DropdownMenuItem;
